<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'au スマートパス 修理代金サポート',
      titleTemplate: '%s | au スマートパス 修理代金サポート',
      htmlAttrs: {
        lang: 'ja',
      },
      link: [
        { rel: 'icon', href: '/static/img/favicon.ico' }
      ]
    }
  }
</script>

<style>
#app {
  height: 100%;
}
</style>
